// GENERATED by scripts/gen_languages_ts.py from api/languages.py - do not edit by hand.
// The languages a video can be made in (story, cast, voices, dub, captions): every language that appears on a Chitravan page and that ElevenLabs speaks
// (https://elevenlabs.io/docs/overview/models). Every picker reads this one list; a test fails when it differs from the API's.
export const STORY_LANGUAGES = [
	{ code: "en", name: "English", english: "English" },
	{ code: "hi", name: "हिन्दी", english: "Hindi" },
	{ code: "ta", name: "தமிழ்", english: "Tamil" },
	{ code: "te", name: "తెలుగు", english: "Telugu" },
	{ code: "bn", name: "বাংলা", english: "Bengali" },
	{ code: "mr", name: "मराठी", english: "Marathi" },
	{ code: "gu", name: "ગુજરાતી", english: "Gujarati" },
	{ code: "kn", name: "ಕನ್ನಡ", english: "Kannada" },
	{ code: "ml", name: "മലയാളം", english: "Malayalam" },
	{ code: "pa", name: "ਪੰਜਾਬੀ", english: "Punjabi" },
	{ code: "ur", name: "اردو", english: "Urdu" },
	{ code: "es", name: "Español", english: "Spanish" },
	{ code: "fr", name: "Français", english: "French" },
	{ code: "de", name: "Deutsch", english: "German" },
	{ code: "pt", name: "Português", english: "Portuguese" },
	{ code: "it", name: "Italiano", english: "Italian" },
	{ code: "nl", name: "Nederlands", english: "Dutch" },
	{ code: "pl", name: "Polski", english: "Polish" },
	{ code: "ru", name: "Русский", english: "Russian" },
	{ code: "tr", name: "Türkçe", english: "Turkish" },
	{ code: "ar", name: "العربية", english: "Arabic" },
	{ code: "ja", name: "日本語", english: "Japanese" },
	{ code: "ko", name: "한국어", english: "Korean" },
	{ code: "zh", name: "中文", english: "Chinese" },
	{ code: "id", name: "Bahasa Indonesia", english: "Indonesian" },
	{ code: "vi", name: "Tiếng Việt", english: "Vietnamese" },
	{ code: "th", name: "ไทย", english: "Thai" },
	{ code: "fil", name: "Filipino", english: "Filipino" },
] as const;

export type LanguageCode = (typeof STORY_LANGUAGES)[number]["code"];

/** Older spellings that episodes and links may still carry. */
const ALIASES: Record<string, string> = { "zh-hans": "zh", "zh-hant": "zh", "zh-cn": "zh", "zh-tw": "zh", "pt-br": "pt", "pt-pt": "pt", tl: "fil" };

/** The platform's code for a stored or typed language ("zh-Hans", "pt-BR", "hi-IN"), or the input unchanged when it is not one of ours. */
export const episodeLanguageCode = (code: string): string => {
	const raw = (code || "").trim().replace("_", "-").toLowerCase();
	for (const c of [raw, ALIASES[raw], raw.split("-")[0], ALIASES[raw.split("-")[0]]]) {
		const hit = STORY_LANGUAGES.find((l) => l.code === c);
		if (hit) return hit.code;
	}
	return code;
};

/** A language's name in English, for sentences and price lines ("Dub Hindi"); the pickers show the language's own name. */
export const languageLabel = (code: string): string => STORY_LANGUAGES.find((l) => l.code === episodeLanguageCode(code))?.english ?? code;
